import { motion } from 'framer-motion'
import * as React from 'react'
import styled from 'styled-components'

type IStyle = {
    $isUppercase?: boolean | undefined
    $width?: string | undefined
    $height?: string | undefined
    $color?: string
    $iconWidth?: string
    $fontSize?: string
    $bgColor?: string
    $translateY?: string
}

const Button = styled(motion.div)<IStyle>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: ${(props) => (props.$width ? props.$width : '100%')};
    height: ${(props) => (props.$height ? props.$height : '50px')};
    padding-left: 30px;
    border: transparent;
    border-radius: 5px;
    box-shadow: none;
    outline: none;
    background-color: ${(props) =>
        props.$bgColor ? props.$bgColor : '#F9FCFC'};
    @media (max-width: 320px) {
        max-height: 50px;
    }
`

const Text = styled.div<IStyle>`
    color: ${(props) => (props.$color ? props.$color : '#1d1d1d')};
    font-family: 'Lato';
    font-size: ${(props) => (props.$fontSize ? props.$fontSize : '15px')};
    letter-spacing: 0.7px;
    text-transform: ${(props) =>
        props.$isUppercase ? 'uppercase' : 'capitalize'};
    padding-left: 20px;
    @media (max-width: 320px) {
        font-size: 14px;
    }
`

const IconWrapper = styled.div<IStyle>`
    width: ${(props) => (props.$iconWidth ? props.$iconWidth : '14px')};
    height: ${(props) => (props.$iconWidth ? props.$iconWidth : '14px')};
    ${(props) =>
        props.$translateY && `transform: translateY(${props.$translateY})`};
`

const Icon = styled.img<IStyle>`
    width: ${(props) => (props.$iconWidth ? props.$iconWidth : '14px')};
`

type Props = {
    onClick: any
    text: string | undefined
    dataAttId?: string | undefined
    isUppercase?: boolean
    width?: string | undefined
    height?: string
    color?: string
    icon: StaticImageData
    iconWidth?: string
    fontSize?: string
}

class BtnWIconNBgNoBorder extends React.Component<Props> {
    render() {
        let {
            onClick,
            icon,
            text,
            isUppercase,
            width,
            height,
            dataAttId,
            color,
            iconWidth,
            fontSize,
        } = this.props
        return (
            <Button
                $width={width}
                $height={height}
                onClick={onClick}
                data-attr={dataAttId ? dataAttId : undefined}
                $color={color}
                whileTap={{ scale: 1.1 }}
            >
                <IconWrapper
                    $iconWidth={iconWidth}
                    $translateY={text === 'about us' ? '-6px' : ''}
                >
                    <Icon src={icon.src}></Icon>
                </IconWrapper>
                <Text $isUppercase={isUppercase} $fontSize={fontSize}>
                    {text}
                </Text>
            </Button>
        )
    }
}

export default BtnWIconNBgNoBorder
